

export enum NetworkActionTypes {
  SET_NETWORK = "SET_NETWORK",
  UPDATE_NETWORK = "UPDATE_NETWORK",
}